import { LandingPageTemplate } from "./components/landing-page-template";
import props from "./brand";
import z from "zod";

const ZAdVariant = z
  .string()
  .nullable()
  .optional()
  .transform((value) => {
    const v = value?.toLowerCase();

    if (v === "telegram") return "telegram";
    if (v === "whatsapp") return "whatsapp";
    if (v === "all") return "all";

    return "whatsapp";
  });

const ZWppButtonText = z.string().nullable().optional();

export type AdVariant = z.infer<typeof ZAdVariant>;
export type WppButtonText = z.infer<typeof ZWppButtonText>;

function App() {
  const searchParams = new URLSearchParams(window.location.search);
  const adVariant = ZAdVariant.parse(searchParams.get("variant"));
  const wppButtonText = ZWppButtonText.parse(searchParams.get("wppButtonText"));

  return (
    <LandingPageTemplate
      {...props}
      adVariant={adVariant}
      wppButtonText={wppButtonText}
    />
  );
}

export default App;
